module.exports = __webpack_public_path__ + "static/media/privacy-bg-1.ce0659c2.svg";